import { render, staticRenderFns } from "./addKanban.vue?vue&type=template&id=1f6a2bfa&scoped=true&"
import script from "./addKanban.vue?vue&type=script&lang=js&"
export * from "./addKanban.vue?vue&type=script&lang=js&"
import style0 from "./addKanban.vue?vue&type=style&index=0&id=1f6a2bfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6a2bfa",
  null
  
)

export default component.exports